import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import Icon from 'components/commons/icon/Icon';

type Props = {
  hideModal: () => void;
  isShowModal: boolean;
  errorCode: string;
};

export const WaitUntilNextUpdateModal = ({
  hideModal: hide,
  isShowModal: isShow,
  errorCode: code,
}: Props): React.ReactElement => {
  return (
    <Modal2 isShow={isShow}>
      <div className="p-4 max-h-modal overflow-y-auto">
        <div className="flex flex-col text-bluegray-700">
          <div className="flex flex-row">
            <Icon name="alert" className="flex items-end h-5 text-red pr-2" />
            <div className="font-bold text-lg">
              連携口座を一度削除し、口座の再連携をお試しください
            </div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="mt-4 text-sm">
            正常に口座連携が完了しませんでした。
            <br />
            <br />
            連携した口座を一度削除し、口座の再連携をお試しください。
            <br />
            <br />
            口座の再連携をお試しいただいても改善しない場合は「みんかぶアセットプランナー」へお問い合わせをお願いします。
            <br />
            (エラーコード：{code})
          </div>
          <div className="mt-6 text-sm text-blue-700">
            <a
              href="https://support.minkabu.jp/hc/ja/requests/new?ticket_form_id=360002511233"
              target="_blank"
              rel="noopener noreferrer">
              お問合わせ
            </a>
          </div>
          <button
            className="mt-6 mb-2 p-2 font-bold text-gray-500 justify-center w-full text-sm"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </div>
    </Modal2>
  );
};
